import { Schema, CleanSchema, get } from '../../../json-transform';

const createHumanTrackingAnalytic = new CleanSchema({
  name: get('name'),
  targets: get('targets'),
  parameters: {
    rate: {
      period: get('parameters.rate.period').asFloat().ifNaN(undefined),
      unit: get('parameters.rate.unit').asOptionValue(),
    },
    tracking: {
      detector_type: get('parameters.tracking.detector_type').asString(),
    },
    probe_count: get('parameters.probe_count').asInt().ifNaN(undefined),
    face_samples: {
      count: get('parameters.face_samples.count').asInt().ifNaN(undefined),
      filters: {
        score: get('parameters.face_samples.filters.score').asFloat().ifNaN(undefined),
        head_pitch: get('parameters.face_samples.filters.head_pitch').asInt().ifNaN(undefined),
        head_roll: get('parameters.face_samples.filters.head_roll').asInt().ifNaN(undefined),
        head_yaw: get('parameters.face_samples.filters.head_yaw').asInt().ifNaN(undefined),
      },
    },
  },
});

export const create = new Schema({
  deferred_task: {
    enable: get('deferred_task.enable').asInt().ifNaN(undefined),
    storage_policy: {
      storage_type: get('deferred_task.storage_policy.storage_type').asString().ifEmptyString(undefined),
    },
  },
  video: {
    url: get('video.url').asString().ifEmptyString(undefined),
    pts: {
      start_time: get('video.pts.start_time').asFloat().ifNaN(undefined),
    },
    orientation: {
      orientation_strategy: get('video.orientation.orientation_strategy').asString().ifEmptyString(undefined),
      angle: get('video.orientation.angle').asInt().ifNaN(undefined),
    },
    timestamp_source: get('video.timestamp_source').asString().ifEmptyString(undefined),
    fps: get('video.fps').asFloat().ifNaN(undefined),
    error_handling: {
      action: get('video.error_handling.action').asString(),
    },
  },
  analytics: get('analytics').asArrayOf((analytic) => {
    switch (analytic.name) {
      case 'human_tracking': return createHumanTrackingAnalytic(analytic);
      default: return analytic;
    }
  }),
});
